var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixPingNotificationsV3Notification from '@wix/ambassador-ping-notifications-v3-notification/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var TemplateChannel;
(function (TemplateChannel) {
    TemplateChannel["WEB_FEED"] = "WEB_FEED";
    TemplateChannel["MOBILE_FEED"] = "MOBILE_FEED";
    TemplateChannel["MOBILE_PUSH"] = "MOBILE_PUSH";
    TemplateChannel["BROWSER"] = "BROWSER";
    TemplateChannel["SMS"] = "SMS";
    TemplateChannel["EMAIL"] = "EMAIL";
    TemplateChannel["KAFKA"] = "KAFKA";
    TemplateChannel["VOICE"] = "VOICE";
})(TemplateChannel || (TemplateChannel = {}));
const _arrayDynamicValue = { items: '_dynamicValue' };
const _dynamicValue = { map: '_mapDynamicValue', array: '_arrayDynamicValue' };
const _mapDynamicValue = { items: 'Map#_dynamicValue' };
const _notifyByAppRequest = { dynamicValues: 'Map#_dynamicValue' };
const _notifyByAppResponse = {};
const _notifyRequest = { dynamicValues: 'Map#_dynamicValue' };
const _notifyResponse = {};
const _resolveRequest = { dynamicValues: 'Map#_dynamicValue' };
const _resolveResponse = {};
/**
 * Sends notifications based on the template and dynamic values provided.
 *
 * > This feature is not yet available to all users.
 *
 * An app can call this endpoint up to 100,000 times per month for each site.
 *
 * When you [create a notification template](https://dev.wix.com/api/rest/wix-notifications/notifications/creating-a-notification-template) in the Wix Dev Center, you are given a notification template ID.
 * Call the Notify endpoint with this ID as `notificationTemplateID` to trigger notifications based on the notification template.
 * If the notification template contains placeholders for dynamic values, provide those values as key-value pairs in the `dynamicValues` array.
 * The values you specify are incorporated seamlessly in the notifications sent out.
 * @param notificationTemplateId - Notification template ID. A notification template specifies the text and recipients for notifications.
 * To obtain a notification template ID, [create a notification template](https://dev.wix.com/api/rest/wix-notifications/notifications/creating-a-notification-template) in the Wix Dev Center.
 * @public
 * @documentationMaturity preview
 * @requiredField notificationTemplateId
 * @adminMethod
 */
export function notify(notificationTemplateId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            notificationTemplateId: '$[0]',
            dynamicValues: '$[1].dynamicValues',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _notifyRequest,
            depSchemas: { _arrayDynamicValue, _dynamicValue, _mapDynamicValue },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _notifyResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([notificationTemplateId, options]);
        const reqOpts = ambassadorWixPingNotificationsV3Notification.notify(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'notificationTemplateId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * NotifyByApp
 * @param notificationTemplateId - notification_template_id
 * @internal
 * @documentationMaturity preview
 * @requiredField notificationTemplateId
 * @requiredField options.appDefId
 * @adminMethod
 */
export function notifyByApp(notificationTemplateId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            notificationTemplateId: '$[0]',
            appDefId: '$[1].appDefId',
            dynamicValues: '$[1].dynamicValues',
            templateTenant: '$[1].templateTenant',
            overrides: '$[1].overrides',
            channelsData: '$[1].channelsData',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _notifyByAppRequest,
            depSchemas: { _arrayDynamicValue, _dynamicValue, _mapDynamicValue },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _notifyByAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([notificationTemplateId, options]);
        const reqOpts = ambassadorWixPingNotificationsV3Notification.notifyByApp(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'notificationTemplateId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param notificationTemplateId - template id
 * @internal
 * @documentationMaturity preview
 * @requiredField notificationTemplateId
 * @adminMethod
 */
export function resolve(notificationTemplateId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            notificationTemplateId: '$[0]',
            dynamicValues: '$[1].dynamicValues',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _resolveRequest,
            depSchemas: { _arrayDynamicValue, _dynamicValue, _mapDynamicValue },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _resolveResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([notificationTemplateId, options]);
        const reqOpts = ambassadorWixPingNotificationsV3Notification.resolve(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'notificationTemplateId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=ping-notifications-v3-notification.universal.js.map